import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../store/reducers/auth';
import { notification } from 'antd';

const TIMEOUT_DURATION = 15 * 60 * 1000; // 15 minutes
//const TIMEOUT_DURATION = 60 * 1000; // 60 seconds for testing

export const useSessionTimeout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const handleLogout = () => {
    dispatch(logoutUser());
    notification.warning({
      message: 'Session Expired',
      description: 'Your session has expired due to inactivity. Please login again.',
      duration: 5,
    });
    navigate('/login', { replace: true });
  };

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(handleLogout, TIMEOUT_DURATION);
  };

  useEffect(() => {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'mousemove'];
    
    resetTimer();

    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  return null;
};
